import { createContext } from "react";

const darkModeContext = createContext()

export default darkModeContext;